import jsonToFormData from 'json-form-data';

import { toast } from '@hivebrite/design-system/Toast';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const createComment = ({ comment, commentAddedImages, currentUser }) => {
  let uploadsAttributes;

  if (commentAddedImages?.length > 0) {
    uploadsAttributes = {
      uploads_attributes: commentAddedImages.map((commentAddedImage) => ({
        asset: commentAddedImage.file,
      })),
    };
  }

  const data = jsonToFormData(
    {
      comment: {
        ...comment,
        ...uploadsAttributes,
      },
    },
    { showLeafArrayIndexes: false },
  );

  return axios
    .post(Routes.user_comments_path(currentUser.id), data)
    .then((response) => response.data);
};

export const updateComment = ({
  comment,
  commentAddedImages,
  commentRemovedImages,
  currentUser,
}) => {
  let uploadsAttributes;

  if (commentAddedImages?.length > 0) {
    uploadsAttributes = {
      uploads_attributes: commentAddedImages.map((commentAddedImage) => ({
        asset: commentAddedImage.file,
      })),
    };
  }

  if (commentRemovedImages?.length > 0) {
    uploadsAttributes = {
      uploads_attributes: commentRemovedImages.map((commentRemovedImage) => ({
        id: commentRemovedImage.id,
        _destroy: true,
      })),
    };
  }

  const data = jsonToFormData(
    {
      comment: {
        ...comment,
        ...uploadsAttributes,
      },
    },
    { showLeafArrayIndexes: false },
  );

  return axios
    .patch(
      Routes.user_comment_path(currentUser.id, comment.id, {
        format: 'json',
      }),
      data,
    )
    .then((response) => response.data);
};

export const destroyComment = ({ id, currentUser, onResponse }) =>
  axios
    .delete(
      Routes.user_comment_path(currentUser.id, id, {
        format: 'json',
      }),
    )
    .then(() => {
      onResponse({ id });
    })
    .catch(() => {
      toast.error(__('Sorry, an error occurred'));
    });

export const createLike = ({
  draftLikes,
  likeableId,
  likeableType,
  onResponse,
  onError,
  userId,
}) =>
  axios
    .post(Routes.user_likes_path(userId), {
      like: {
        likeable_id: likeableId,
        likeable_type: likeableType,
      },
    })
    .then((response) => {
      onResponse(response?.data.like, draftLikes);
    })
    .catch(() => {
      onError();
      toast.error(__('Sorry, an error occurred'));
    });

export const destroyLike = ({
  draftLikes,
  likeableType,
  likeId,
  onResponse,
  onError,
}) =>
  axios
    .delete(Routes.user_like_path(likeableType, likeId))
    .then(() => {
      onResponse(draftLikes);
    })
    .catch(() => {
      onError();
      toast.error(__('Sorry, an error occurred'));
    });

export const vote = ({
  voteableId,
  voteableType,
  onResponse,
  onError,
  state,
}) =>
  axios
    .post(Routes.votes_path(), {
      vote: {
        voteable_type: voteableType,
        voteable_id: voteableId,
        state,
      },
    })
    .then((response) => {
      onResponse(response?.data.vote);
    })
    .catch(() => {
      onError();
      toast.error(__('Sorry, an error occurred'));
    });
